export default __webpack_public_path__ + "static/media/sadem.8894102f.jpg";